(function() {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

jQuery(function() {
  var available_race_numbers, check_age, get_url_separator, series_invalid_race_number, series_valid_race_number, validate_race_number;
  $(document).on("keyup", ".entry_race_number_field", function(e) {
    return validate_race_number(e.target);
  });
  validate_race_number = function(field) {
    var _int_value, ref;
    _int_value = parseInt(field.value, 10);
    if (field.value === "" || isNaN(_int_value)) {
      return series_valid_race_number(field);
    } else if (ref = _int_value.toString(), indexOf.call(available_race_numbers(field), ref) >= 0) {
      return series_valid_race_number(field);
    } else {
      return series_invalid_race_number(field);
    }
  };
  series_valid_race_number = function(field) {
    var container;
    $(field).removeClass("is-invalid at-invalid");
    container = $(field).closest("div");
    container.removeClass("is-invalid at-invalid");
    if (container.find(".invalid-feedback").length > 0) {
      return container.find(".invalid-feedback").remove();
    }
  };
  series_invalid_race_number = function(field) {
    var container;
    container = $(field).closest("div");
    $(field).addClass("is-invalid at-invalid");
    container.addClass("is-invalid at-invalid");
    if (container.find(".invalid-feedback").length === 0) {
      return container.find("input").after('<div class="invalid-feedback at-invalid-feedback">number is not available</div>');
    } else {
      return container.find(".invalid-feedback").text("number is not available");
    }
  };
  available_race_numbers = function(field) {
    var container;
    container = $(field).closest(".entry_race_number");
    return $(container.find(".race_numbers")[0]).data("numbers") || [];
  };
  $(document).on("click", ".entry_race_number .view_available_numbers", (function(_this) {
    return function(e) {
      var container;
      e.preventDefault();
      container = $(e.target).closest(".entry_race_number");
      return $(container.find(".modal")[0]).modal("show");
    };
  })(this));
  $(document).on("click", ".entry_race_number .available_race_numbers_table td", (function(_this) {
    return function(e) {
      var container, field;
      container = $(e.target).closest(".entry_race_number");
      field = container.find(".entry_race_number_field")[0];
      $(field).val($(e.target).data("number"));
      $(container.find(".modal")[0]).modal("hide");
      return validate_race_number(field);
    };
  })(this));
  get_url_separator = function(url) {
    if (/\?/.test(url)) {
      return "&";
    } else {
      return "?";
    }
  };
  check_age = function(dob, age) {
    var dd, md, now, yd;
    now = new Date();
    yd = now.getUTCFullYear() - dob.getUTCFullYear();
    md = now.getUTCMonth() - dob.getUTCMonth();
    dd = now.getUTCDate() - dob.getUTCDate();
    if (yd > age) {
      return true;
    }
    if (yd < age) {
      return false;
    }
    if (md > 0) {
      return true;
    }
    if (md < 0) {
      return false;
    }
    return dd >= 0;
  };
  $(document).on("change", "#person_birthdate_3i, #person_birthdate_2i, #person_birthdate_1i", (function(_this) {
    return function(e) {
      var _age_check, _date, _day, _month, _year;
      _day = $("#person_birthdate_3i").val();
      _month = $("#person_birthdate_2i").val();
      _year = $("#person_birthdate_1i").val();
      _date = Date.parse(_year + "-" + _month + "-" + _day);
      _age_check = check_age(new Date(_date), 18);
      if (_age_check) {
        return $("#legal_guadian").fadeOut('fast');
      } else {
        return $("#legal_guadian").fadeIn('fast');
      }
    };
  })(this));
  return $(document).on("change", "#user_birthdate_3i, #user_birthdate_2i, #user_birthdate_1i", (function(_this) {
    return function(e) {
      var _age_check, _date, _day, _month, _year;
      _day = $("#user_birthdate_3i").val();
      _month = $("#user_birthdate_2i").val();
      _year = $("#user_birthdate_1i").val();
      _date = Date.parse(_year + "-" + _month + "-" + _day);
      _age_check = check_age(new Date(_date), 18);
      if (_age_check) {
        return $("#legal_guadian").fadeOut('fast');
      } else {
        return $("#legal_guadian").fadeIn('fast');
      }
    };
  })(this));
});

jQuery(function() {
  return $(".form-control.select option[value='-999']").prop("disabled", true);
});

$(document).on("change", "select.input_with_other", function(e) {
  var _field, _value;
  _value = e.target.value;
  _field = $(e.target).data("field");
  if (_value === "-1") {
    return $("#" + _field).fadeIn("fast");
  } else {
    return $("#" + _field).fadeOut("fast");
  }
});

$(document).on("click", "#deliver_to_track", function(e) {
  var _order_id, _value;
  _value = $(e.target).prop("checked");
  _order_id = $(e.target).data("order-id");
  return $.ajax("/orders/orders/" + _order_id, {
    type: "PUT",
    data: {
      "order[deliver_to_track]": _value
    }
  });
});

}).call(window);
